import {Component, computed, inject} from '@angular/core';
import {rxResource} from '@angular/core/rxjs-interop';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {VulcanIconComponent} from '@eagle-i/vulcan-component-library';
import html2canvas from 'html2canvas';
import JSZip from 'jszip';
import {ReliabilityService} from '../../../../../../../services/reliability.service';
import {BaseStateReportWidget} from '../base-state-report-widget';

@Component({
  selector: 'tgrid-reliability-widget',
  templateUrl: './reliability-widget.component.html',
  styleUrls: ['./reliability-widget.component.scss'],
  imports: [MatCardModule, MatButtonModule, VulcanIconComponent],
})
export class ReliabilityWidgetComponent extends BaseStateReportWidget {
  private reliabilityService = inject(ReliabilityService);

  // Text for display
  protected saifiMedText = 'events (Major Event Days)';
  protected saifiNoMedText = 'events (Without Major Event Days)';
  protected saidiMedText = 'min (Major Event Days)';
  protected saidiNoMedText = 'min (Without Major Event Days)';
  protected disclaimer = '* All values are computed using IEEE Standards';

  // Load reliability metrics based on state and year parameters changes
  private reliabilityMetrics = rxResource({
    request: () => ({stateAbbreviation: this.stateParam(), year: this.yearParam()}),
    loader: ({request}) =>
      this.reliabilityService.getReliabilityMetrics(request.stateAbbreviation, request.year),
  });

  protected saidiWith = computed(() => this.reliabilityMetrics.value()?.saidiMeds);
  protected saidiWithout = computed(() => this.reliabilityMetrics.value()?.saidiNoMeds);
  protected saifiWith = computed(() => this.reliabilityMetrics.value()?.saifiMeds);
  protected saifiWithout = computed(() => this.reliabilityMetrics.value()?.saifiNoMeds);


  protected override async export(): Promise<void> {
    const filename = `reliability_report_${this.stateParam()}_${this.yearParam()}`;
    const zip = new JSZip();

    // Create text file
    const textContent = [
      'SAIFI and SAIDI Values',
      'SAIFI:',
      `  ${this.saifiWith()} ${this.saifiMedText}`,
      `  ${this.saifiWithout()} ${this.saifiNoMedText}`,
      'SAIDI:',
      `  ${this.saidiWith()} ${this.saidiMedText}`,
      `  ${this.saidiWithout()} ${this.saidiNoMedText}`,
      '',
      this.disclaimer,
    ].join('\n\n');

    zip.file(`${filename}.txt`, textContent);

    // Create PNG from HTML
    try {
      const canvas = await html2canvas(this.exportContent()?.nativeElement, {
        backgroundColor: '#fff',
        removeContainer: true,
      });
      const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/png'));
      if (blob) {
        zip.file(`${filename}.png`, blob);
        const zipBlob = await zip.generateAsync({type: 'blob'});
        const url = URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${filename}.zip`;
        link.click();
        URL.revokeObjectURL(url);
      }
      this.snackBar.open('Export downloaded successfully', 'Close', { duration: 3000 });
    } catch (err) {
      console.error(err);
      this.snackBar.open('Export failed. Please try again.', 'Close', { duration: 3000 });
    }
  }

}
